import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';
import { HttpWithCacheService } from '../http-with-cache.service';
import { RestrictedWord, OstrakoClient } from '@aksia/models';

@Injectable({
  providedIn: 'root',
})
export class RestrictedWordService extends HttpWithCacheService {
  private api = inject(CedricApiService);
  private controller: string = 'RestrictedWords';

  constructor() {
    super();
  }

  getRestrictedWords(
    forceHttp = false,
  ): Observable<{ restrictedWords: RestrictedWord[] }> {
    return this.api.post(`${this.controller}/GetRestrictedWords`, {});
  }

  getOstrakoClientNames(
    forceHttp = false,
  ): Observable<{ clients: OstrakoClient[] }> {
    return this.api.post(`${this.controller}/GetOstrakoClientNames`, {});
  }

  createRestrictedWord(restrictedWord: RestrictedWord): Observable<any> {
    return this.api.post(
      `${this.controller}/CreateRestrictedWord`,
      restrictedWord,
    );
  }

  updateRestrictedWord(restrictedWord: RestrictedWord): Observable<any> {
    return this.api.post(
      `${this.controller}/UpdateRestrictedWord`,
      restrictedWord,
    );
  }

  deleteRestrictedWord(restrictedWordId: number): Observable<any> {
    return this.api.post(`${this.controller}/DeleteRestrictedWord`, {
      id: restrictedWordId,
    });
  }
}
